export enum ChangePasswordForm {
    changePasswordFormTitle='Promena lozinke',
    changePasswordPlaceholderUsername='Korisničko ime',
    changePasswordPlaceholderPassword='Lozinka',
    changePasswordPlaceholderConfirmPassword='Potvrditi lozinku',
    chagePasswordSuccessMessage='Lozinka je uspešno promenjena!'
}

export enum ChangePasswordInfoForm {
    changePasswordInfoFormTitle='Zaboravili ste lozinku?',
}